import { addSubjectMatter, updateSubjectMatter } from '@api/announcement';
import { AddSubjectMatterInterface } from '@api/announcement/type';
import ZeissButton from '@components/button';
import { subjectMatterBrandKeyArr } from '@components/ProjectFromComponents/data';
import ZeissModal from '@components/zeiss-modal';
import { rendercomponents, RenderFormDomInterface } from '@utils/formRender';
import { dateFormat, getItemByKey, valToString } from '@utils/tool';
import { initialSubjectMatterItemValues } from '@views/pages/AnnouncementList/Announcement/CreateAnnouncement';
import { Col, Form, Row, Space } from 'antd';
import dayjs from 'dayjs';
import { useEffect } from 'react';
import { ADDSUBJECTMATTER_DETAIL } from './columns';
import './index.scss';
// import { rendercomponents, RenderFormDomInterface } from '@views/pages/AnnouncementList/tools';
interface Props {
  open: boolean;
  setOpen: (val: boolean) => void;
  details?: any;
  getAnnInfo: () => void;
  record?: any;
  dict: any;
  // dicList: any;
  // systemCity: any;
}
// interface dictInterface {
//   dictValue?: string;
//   dictKey?: string | any;
// }
interface FormInterface {
  label: string;
  required: boolean;
  type: string;
  name: string;
  placeholder?: string;
}

export const CreateSubjectMatterPopup = ({
  open,
  setOpen,
  details,
  getAnnInfo,
  record,
  dict
}: Props) => {
  const [form] = Form.useForm();
  const {
    importType: importTypeOptionsList,
    currency,
    productLine: productLineList,
    subjectMatterBrand: subjectMatterBrandList
  } = dict;
  const subjectMatterBrandKeyFromForm = Form.useWatch(
    'subjectMatterBrandKey',
    form
  );
  const subjectMatterNumberFromForm = Form.useWatch(
    'subjectMatterNumber',
    form
  );
  const totalAmountCurrencyFromForm: string = Form.useWatch(
    'totalAmountCurrency',
    form
  );
  const totalAmountFromForm = Form.useWatch('totalAmount', form);
  const importTypeFromForm = Form.useWatch('importType', form);
  // const { productLine: dict } = DicListHook();
  // const { productLine } = dict;

  // 兼容客户需求Radio点击能取消。。。
  const formClick = (e: any) => {
    e.stopPropagation();
    e.preventDefault();

    if (e.target.value === importTypeFromForm) {
      const obj = form.getFieldsValue();
      form.setFieldsValue({
        ...obj,
        importType: ''
      });
    }
  };

  const formatSubjectMatterArr = (arr: any[]) => {
    const mapArr = arr
      .filter((item) => {
        if (
          item.name === 'subjectMatterBrand' &&
          !subjectMatterBrandKeyArr.find(
            (v) => v === subjectMatterBrandKeyFromForm
          )
        ) {
          return false;
        }
        return true;
      })
      .map((item) => {
        if (item.name === 'importType') {
          item.onClick = formClick;
        }
        return {
          ...item
        };
      });

    return mapArr;
  };

  const onFinish = async (val: AddSubjectMatterInterface) => {
    const { noticeCode } = details || {};
    // if (!val.successfulPrice && !val.successfulPriceRemark)
    //   return message.error(subjectMatterErrorText);
    const {
      productLineKey,
      importType,
      subjectMatterCurrency,
      // successfulPriceCurrency,
      estimatedPurchaseTime,
      totalAmountCurrency,
      subjectMatterBrandKey,
      subjectMatterBrand
    } = val;

    const requestParams: any = {
      ...val,
      noticeCode,
      subjectMatterBrandKey,
      subjectMatterBrand:
        subjectMatterBrand ??
        getItemByKey(subjectMatterBrandList, 'dictKey', subjectMatterBrandKey)
          ?.dictValue,
      productLineName: getItemByKey(productLineList, 'dictKey', productLineKey)
        ?.dictValue,
      importTypeValue: getItemByKey(
        importTypeOptionsList,
        'dictKey',
        importType
      )?.dictValue,
      subjectMatterCurrencyValue: getItemByKey(
        currency,
        'dictKey',
        subjectMatterCurrency
      )?.dictValue,
      // successfulPriceCurrencyValue: getItemByKey(
      //   currency,
      //   'dictKey',
      //   successfulPriceCurrency
      // )?.dictValue,
      totalAmountCurrencyValue: getItemByKey(
        currency,
        'dictKey',
        totalAmountCurrency
      )?.dictValue,
      estimatedPurchaseTime: dateFormat(estimatedPurchaseTime)
      // importTypeValue: val.importType
      //   ? val.importType == 1
      //     ? '国产'
      //     : '进口'
      //   : undefined,
      // subjectMatterCurrency: val['subjectMatterPriceAmount']
      //   ? Number(val['subjectMatterPriceAmount'].split('-')[0])
      //   : undefined,
      // subjectMatterCurrencyValue: val['subjectMatterPriceAmount']
      //   ? val['subjectMatterPriceAmount'].split('-')[1]
      //   : undefined,
      // // successfulPriceCurrency: val['successfulPriceAmount']
      // //   ? Number(val['successfulPriceAmount'].split('-')[0])
      // //   : undefined,
      // // successfulPriceCurrencyValue: val['successfulPriceAmount']
      // //   ? val['successfulPriceAmount'].split('-')[1]
      // //   : undefined,
      // totalAmountCurrency: val['totalAmountAmount']
      //   ? Number(val['totalAmountAmount'].split('-')[0])
      //   : undefined,
      // totalAmountCurrencyValue: val['totalAmountAmount']
      //   ? val['totalAmountAmount'].split('-')[1]
      //   : undefined,
      // productLineKey: val.productLineKey && Number(val.productLineKey),
      // productLineName:
      //   val.productLineKey &&
      //   productLine?.filter(
      //     (x: dictInterface) => x.dictKey == val.productLineKey
      //   )?.[0].dictValue,
      // estimatedPurchaseTime: val.estimatedPurchaseTime
      //   ? dayjs(val.estimatedPurchaseTime).format(DEFAULT_DATETIME_FORMAT)
      //   : undefined
    };

    if (record?.subjectMatterCode) {
      await updateSubjectMatter({
        ...requestParams,
        subjectMatterCode: record?.subjectMatterCode
      });
    } else {
      await addSubjectMatter({
        ...requestParams,
        subjectMatterNumber: val.subjectMatterNumber || 1
      });
    }
    getAnnInfo && getAnnInfo();
    setOpen(false);
  };

  const handleCancel = () => {
    setOpen(false);
  };

  useEffect(() => {
    if (
      subjectMatterNumberFromForm &&
      totalAmountFromForm &&
      Number(totalAmountFromForm)
    ) {
      form.setFieldValue(
        'subjectMatterPrice',
        (totalAmountFromForm / subjectMatterNumberFromForm).toFixed(2)
      );
    } else {
      form.setFieldValue('subjectMatterPrice', null);
    }
  }, [subjectMatterNumberFromForm, totalAmountFromForm]);

  useEffect(() => {
    if (totalAmountCurrencyFromForm) {
      form.setFieldValue(
        'subjectMatterCurrency',
        `${form.getFieldValue('totalAmountCurrency')}`
      );
    }
  }, [totalAmountCurrencyFromForm]);

  // const getFieldValue = (value: any, type: string) => {
  //   if (type === 'amount') {
  //     return value && value.replace(/[^\d]+/g, '');
  //   } else {
  //     return value;
  //   }
  // };

  useEffect(() => {
    if (!open) return;
    if (record?.subjectMatterCode) {
      form.setFieldsValue({
        ...record,
        // productLineKey: record.productLineKey && `${record.productLineKey}`,
        // subjectMatterNumber: record.subjectMatterNumber || 1,
        // subjectMatterPriceAmount: record['subjectMatterCurrency']
        //   ? `${record['subjectMatterCurrency']}-${record['subjectMatterCurrencyValue']}`
        //   : undefined,
        // // successfulPriceAmount: record['successfulPriceCurrency']
        // //   ? `${record['successfulPriceCurrency']}-${record['successfulPriceCurrencyValue']}`
        // //   : undefined,
        // totalAmountAmount: record['totalAmountCurrency']
        //   ? `${record['totalAmountCurrency']}-${record['totalAmountCurrencyValue']}`
        //   : undefined,
        // estimatedPurchaseTime: record.estimatedPurchaseTime
        //   ? dayjs(record.estimatedPurchaseTime)
        //   : ''
        estimatedPurchaseTime: record.estimatedPurchaseTime
          ? dayjs(record.estimatedPurchaseTime)
          : null,
        productLineKey: valToString(record.productLineKey),
        importType: valToString(record.importType),
        subjectMatterCurrency: valToString(record.subjectMatterCurrency),
        totalAmountCurrency: valToString(record.totalAmountCurrency),
        subjectMatterBrandKey: valToString(record.subjectMatterBrandKey),
        subjectMatterBrand: subjectMatterBrandKeyArr.find(
          (v) => v === valToString(record.subjectMatterBrandKey)
        )
          ? record.subjectMatterBrand
          : ''
      });
    } else {
      form.resetFields();
      form.setFieldsValue({
        // subjectMatterPriceAmount: `1-CNY`,
        // successfulPriceAmount: `1-CNY`,
        // totalAmountAmount: `1-CNY`
        ...initialSubjectMatterItemValues
      });
    }
  }, [record, open]);

  const obj: RenderFormDomInterface = {
    // optionCallback: renderSelectOptions,
  };

  const onFormChange = () => {};

  return (
    <ZeissModal
      open={open}
      width={740}
      centered
      footer={null}
      onCancel={handleCancel}
    >
      <div className="pc-subLayout">
        <div className="pc-sub-title">
          {record?.subjectMatterCode ? '修改' : '新建'}标的物
        </div>
        <Form
          form={form}
          layout="vertical"
          onFinish={onFinish}
          onValuesChange={onFormChange}
          preserve={false}
          initialValues={{
            subjectMatter: [initialSubjectMatterItemValues]
          }}
        >
          <Row gutter={[24, 0]} justify={'space-between'}>
            {formatSubjectMatterArr(ADDSUBJECTMATTER_DETAIL).map(
              (x: FormInterface) => (
                <Col span={11} key={x.name}>
                  <Form.Item
                    label={x.label}
                    name={x.name}
                    rules={[
                      {
                        required: x.required
                      }
                    ]}
                    // normalize={(value) => getFieldValue(value, x.type)}
                  >
                    {rendercomponents({
                      ...obj,
                      data: x,
                      dicList: dict
                    })}
                  </Form.Item>
                </Col>
              )
            )}
          </Row>
          <Space className="pc-createAnn-footer" size="middle">
            <ZeissButton className="pc-createAnn-cancel" onClick={handleCancel}>
              取消
            </ZeissButton>
            <ZeissButton
              type="primary"
              className="pc-createAnn-sales"
              htmlType="submit"
            >
              确认
            </ZeissButton>
          </Space>
        </Form>
      </div>
    </ZeissModal>
  );
};
